import React, { useEffect, useState } from "react";
import login from "../assets/login.svg";
import background from "../assets/background.png";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Login = () => {
  const navigate = useNavigate();
  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleNumber = (e) => {
    setNumber(e.target.value);
    setError("");
    setSuccess("");
  };

  let aimsToken = localStorage.getItem("aimsToken");
  useEffect(() => {
    if (aimsToken) {
      navigate("/");
    }
  }, []);

  const handleSendOtp = async () => {
    if (number.length !== 10 || isNaN(number)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }
    try {
      const response = await fetch(
        `https://anoopam.com/aims/api/?action=otp&mobile=${number}&format=new`
      );
      const data = await response.json();

      if (data.status) {
        Swal.fire({
          text: data?.message,
          icon: "success",
        });
        setStep(2);
      } else {
        Swal.fire({
          title: "",
          text: data.message,
          icon: "error",
        });
      }
    } catch (err) {
      Swal.fire({
        title: "",
        text:
          err?.message ||
          "An error occurred while sending OTP. Please try again.",
        icon: "error",
      });
      // setError("An error occurred while sending OTP. Please try again.");
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (!isNaN(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next input
      if (value !== "" && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      }
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 4) {
      Swal.fire({
        title: "",
        html: `<strong>Please enter a 4-digit OTP.</strong>`, // Bold text
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: " #034da2", // Red button
      });

      return;
    }
    try {
      const response = await fetch(
        `https://anoopam.com/aims/api/?action=getdetail&mobile=${number}&otp=${enteredOtp}&format=new`
      );
      const data = await response.json();

      if (data.status) {
        Swal.fire({
          text: data?.message,
          icon: "success",
        });
        localStorage.setItem("aimsToken", true);
        localStorage.setItem(
          "aimsUserMemberId",
          data?.data?.data?.member?.memberid
        );
        localStorage.setItem(
          "aimsUserUUId",
          data?.data?.data?.member?.data?.uuid
        );

        navigate("/");
      } else {
        Swal.fire({
          title: "",
          html: `<strong>${data?.message} "
            }</strong>`, // Bold text
          icon: "error",
        });
      }
    } catch (err) {
      Swal.fire({
        title: "",
        html: `<strong>${
          err || "An error occurred while verifying OTP. Please try again."
        }</strong>`, // Bold text
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: " #034da2", // Red button
      });
    }
  };

  const handleChangeMobile = () => {
    setStep(1);
    setOtp(["", "", "", ""]);
    setError("");
    setSuccess("");
  };

  return (
    <div
      className=" py-5 mt-5"
      style={{
        background: "rgb(246,247,249)",
      }}
    >
      {step === 1 && (
        <div className="container  d-flex justify-content-center align-items-center">
          <div
            style={{ background: "rgb(241,248,252)" }}
            className="p-4 rounded-5 text-center border col-12 col-md-8 col-lg-6"
          >
            <div className="login">
              <img src={login} alt="Anoopam Mission" className="img-fluid" />
            </div>

            <h1 style={{ color: "#001F43" }} className="fw-bold mt-2">
              Welcome to Anoopam Mission Information Management System (AIMS)
            </h1>
            <p className="text-color">Please sign-in to your account</p>
            <div className="d-flex flex-column align-items-center">
              <div className="col-12 col-md-8">
                <input
                  type="text"
                  className="form-control fw-semibold"
                  placeholder="Mobile"
                  value={number}
                  onChange={handleNumber}
                  maxLength="10"
                />
              </div>
              {error && (
                <p
                  className="text-danger mt-2 fw-semibold"
                  style={{ fontSize: "1rem" }}
                >
                  {error}
                </p>
              )}
              {success && (
                <p
                  className="text-success mt-2 fw-semibold"
                  style={{ fontSize: "1rem" }}
                >
                  {success}
                </p>
              )}
            </div>

            <button
              onClick={handleSendOtp}
              style={{ background: "#001F43" }}
              className="btn mt-4 fw-semibold text-white col-12 col-md-8"
            >
              Send OTP
            </button>
            <p className="mt-3 text-color">
              Not registered yet?{" "}
              <Link to="/registration" className="text-color fw-bold">
                Create an account
              </Link>
            </p>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="container  d-flex justify-content-center align-items-center">
          <div
            style={{ background: "rgb(241,248,252)" }}
            className="p-4 rounded-5 text-center border col-12 col-md-8 col-lg-6"
          >
            <div className="login">
              <img src={login} alt="Anoopam Mission" className="img-fluid" />
            </div>

            <h1 style={{ color: "#001F43" }} className="fw-bold mt-2">
              Mobile Verification
            </h1>
            <p className="text-color">
              One time password sent to your mobile {number}
            </p>
            <div className="d-flex gap-2 justify-content-center">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="number"
                  maxLength="1"
                  className="form-control text-center fw-bold"
                  style={{ width: "50px" }}
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleBackspace(e, index)}
                />
              ))}
            </div>

            <button
              onClick={handleVerifyOtp}
              style={{ background: "#001F43" }}
              className="btn mt-4 fw-semibold text-white col-12 col-md-8"
            >
              Verify OTP
            </button>
            <button
              onClick={handleSendOtp}
              style={{ background: "#001F43" }}
              className="btn mt-2 fw-semibold text-white col-12 col-md-8"
            >
              Send OTP Again
            </button>
            <p
              onClick={handleChangeMobile}
              className="mt-3 text-color fw-bold"
              style={{ cursor: "pointer" }}
            >
              Change Mobile
            </p>
            {error && (
              <p
                className="text-danger mt-2 fw-semibold"
                style={{ fontSize: "1rem" }}
              >
                {error}
              </p>
            )}
            {success && (
              <p
                className="text-success mt-2 fw-semibold"
                style={{ fontSize: "1rem" }}
              >
                {success}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;

// import React, { useState } from "react";
// import login from "../assets/login.svg";

// import background from "../assets/background.png";
// import { sendOTP } from "../api/members/members";

// const Login = () => {
//   const [number, setNumber] = useState("");
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [step, setStep] = useState(1);
//   const [error, setError] = useState("");
//   // const [success, setSuccess] = useState("");

//   const handleNumber = (e) => {
//     setNumber(e.target.value);
//     setError("");
//   };

//   // const handleSendOtp = async () => {
//   //   if (number.length !== 10 || isNaN(number)) {
//   //     setError("Please enter a valid 10-digit mobile number");
//   //   } else {
//   //     try {
//   //       const responseData = await sendOTP(number);
//   //       if (responseData.status) {
//   //         setStep(2);
//   //         setSuccess("OTP sent successfully to your mobile.");
//   //       }
//   //     } catch (error) {
//   //       setError("Please enter a valid 10-digit mobile number");
//   //     }
//   //   }
//   // };
//   const handleSendOtp = () => {
//     if (number.length !== 10 || isNaN(number)) {
//       setError("Please enter a valid 10-digit mobile number");
//     } else {
//       setStep(2);
//     }
//   };

//   const handleOtpChange = (e, index) => {
//     const value = e.target.value;
//     if (!isNaN(value) && value.length <= 1) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);

//       // Move focus to the next input
//       if (value !== "" && index < 3) {
//         document.getElementById(`otp-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleBackspace = (e, index) => {
//     if (e.key === "Backspace" && otp[index] === "") {
//       if (index > 0) {
//         document.getElementById(`otp-${index - 1}`).focus();
//       }
//     }
//   };

//   const handleChangeMobile = () => {
//     setStep(1);
//     setOtp(["", "", "", ""]);
//   };

//   return (
//     <div
//     // style={{
//     //   backgroundImage: `url(${background})`,
//     //   backgroundSize: "cover",
//     //   backgroundRepeat: "no-repeat",
//     //   backgroundPosition: "center",
//     //   height: "100vh",
//     // }}
//     >
//       {step === 1 && (
//         <div className="container vh-100 d-flex justify-content-center align-items-center">
//           <div
//             style={{ background: "rgb(241,248,252)" }}
//             className="p-4 rounded-5 text-center border col-12 col-md-8 col-lg-6"
//           >
//             <div className="login">
//               <img src={login} alt="Anoopam Mission" className="img-fluid" />
//             </div>

//             <h1 style={{ color: "#001F43" }} className="fw-bold mt-2">
//               Welcome to AIMS!
//             </h1>
//             <p className="text-color">Please sign-in to your account</p>
//             <div className="d-flex flex-column align-items-center">
//               <div className="col-12 col-md-8">
//                 <input
//                   type="mobilenumber"
//                   className="form-control fw-semibold"
//                   placeholder="Mobile"
//                   value={number}
//                   onChange={handleNumber}
//                 />
//               </div>
//               {error && (
//                 <p
//                   className="text-danger mt-2 fw-semibold"
//                   style={{ fontSize: "1rem" }}
//                 >
//                   {error}
//                 </p>
//               )}
//               {/* {success && (
//                 <p
//                   className="text-success mt-2 fw-semibold"
//                   style={{ fontSize: "1rem" }}
//                 >
//                   {success}
//                 </p>
//               )} */}
//             </div>

//             <button
//               onClick={handleSendOtp}
//               style={{ background: "#001F43" }}
//               className="btn mt-4 fw-semibold text-white col-12 col-md-8"
//             >
//               Send OTP
//             </button>
//             <p className="mt-3 text-color">
//               No register detail?{" "}
//               <a href="#" className="text-color fw-bold">
//                 Create an account
//               </a>
//             </p>
//           </div>
//         </div>
//       )}

//       {step === 2 && (
//         <div className="container vh-100 d-flex justify-content-center align-items-center">
//           <div
//             style={{ background: "rgb(241,248,252)" }}
//             className="p-4 rounded-5 text-center border col-12 col-md-8 col-lg-6"
//           >
//             <div className="login">
//               <img src={login} alt="Anoopam Mission" className="img-fluid" />
//             </div>

//             <h1 style={{ color: "#001F43" }} className="fw-bold mt-2">
//               Mobile Verification
//             </h1>
//             <p className="text-color">
//               One time password sent to your mobile {number}
//             </p>
//             <div className="d-flex gap-2 justify-content-center">
//               {otp.map((digit, index) => (
//                 <input
//                   key={index}
//                   id={`otp-${index}`}
//                   type="text"
//                   maxLength="1"
//                   className="form-control text-center fw-bold"
//                   style={{ width: "50px" }}
//                   value={digit}
//                   onChange={(e) => handleOtpChange(e, index)}
//                   onKeyDown={(e) => handleBackspace(e, index)}
//                 />
//               ))}
//             </div>

//             <button
//               style={{ background: "#001F43" }}
//               className="btn mt-4 fw-semibold text-white col-12 col-md-8"
//             >
//               Verify OTP
//             </button>
//             <button
//               onClick={handleSendOtp}
//               style={{ background: "#001F43" }}
//               className="btn mt-2 fw-semibold text-white col-12 col-md-8"
//             >
//               Send OTP Again
//             </button>
//             <p
//               onClick={handleChangeMobile}
//               className="mt-3 text-color fw-bold"
//               style={{ cursor: "pointer" }}
//             >
//               Change Mobile
//             </p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Login;
